
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/slots",
      function () {
        return require("private-next-pages/slots/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/slots"])
      });
    }
  